import React, { useEffect } from "react";
import { Col, DatePicker, Flex, Row } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Input, Button, Select } from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import dayjs from "dayjs";
import { editSubscriptionPlanAction } from "../../../../../../redux/services/subscription-plan-update/subscriptionPlanServicesUpdate";
import {
  baseRouteMaker,
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../../constants/routeConsts";
import { ArrowLeftOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";

const UpdateSubcription = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();

  const location = useLocation()?.state;
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  // const initialValues = {
  //   price: "",
  //   freeLogins: "",
  //   duration: null,
  // };
  const [periodOptions] = useState([
    { value: "add", label: "Add" },
    // { value: "subtract", label: "Subtract" },
  ]);
  /* function definition to get table data */

  useEffect(() => {
    if (location) {
      form.setFieldsValue({
        date: dayjs(location?.expire_date_time),
        addLogin: location?.default_logins,
      });
    }
  }, [form, location]);

  /* Form submit handler */
  const onSubmit = (values) => {
    const dataToBeSent = {
      action: "add",
      default_logins: Number(values?.addLogin),
      expire_date_time: dayjs(values?.date, "YYYY/MM/DD") || null,
      _id: location?._id,
    };

    dispatch(editSubscriptionPlanAction(dataToBeSent, setLoading, navigate))
  };
  /* Form submit handler */

  const disabledDate = (value) => {
    const allowedEndDate = new Date(dayjs(location?.expire_date_time));
    return value < allowedEndDate.setDate(allowedEndDate.getDate());
  };

  return (
    <div>
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() =>
              navigate(baseRouteMakerForSuperAdmin(routes.ACTIVE_SUBSCRIPTION))
            }
          />
          <Title level={2}>{t("UpdateSubs")}</Title>
        </Flex>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          {/* <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                name="duration"
                initialValue="add"
                label={
                  <RequiredLabel
                    text={t("appointmentInfo.action")}
                    required={true}
                  />
                }
              >
                <Select loading={selectListLoader} options={periodOptions} />
              </Form.Item>
            </Col>
          </Row> */}

          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                label={<RequiredLabel text={t("Modules.addOns.defaultLogin")} required={true} />}
                name="addLogin"
                rules={[
                  {
                    required: true,
                    message: "Please enter default logins",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value < 1)
                        return Promise.reject(
                          `${t("Modules.addOns.defaultLogin")} ${t(
                            "CommonUtils.shouldBeGreaterThan0"
                          )}`
                        );
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  type="number"
                  onKeyDown={(e) => allowCharactersOnlyForDecimalNumbers(e)}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t(
                      "Modules.DiscountCodes.DiscountCodesForm.expiryDate"
                    )}
                    required={true}
                  />
                }
                name="date"
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.DiscountCodes.DiscountCodesForm.pleaseSelectExpiryDate"
                    ),
                  },
                ]}
              >
                <DatePicker
                  onKeyDown={(e) => e.preventDefault()}
                  style={{ width: "100%" }}
                  placeholder={t(
                    "Modules.DiscountCodes.DiscountCodesForm.selectExpiryDate"
                  )}
                  disabledDate={disabledDate}
                  format={"DD-MM-YYYY"}
                />
              </Form.Item>
            </Col>

            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Flex>
    </div>
  );
};

export default UpdateSubcription;
